export default "__VITE_ASSET__Cc1wniGA__"